(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["buy-buttons"] && !Shopify.designMode) return;
  try {
    class DiscountCodeCopy extends HTMLElement {
    connectedCallback() {
      this.copyButton = this.querySelector('[data-discount-code-copy]');
      this.status = this.querySelector('[data-discount-code-status]');

      if (!this.copyButton) return;

      this.defaultLabel = this.copyButton.textContent.trim();
      this.copyButton.addEventListener('click', () => this.copyCode());
    }

    async copyCode() {
      try {
        await navigator.clipboard.writeText(this.dataset.code);
        this.showCopiedState();
      } catch (error) {
        const textArea = document.createElement('textarea');
        textArea.value = this.dataset.code;
        textArea.setAttribute('readonly', '');
        textArea.style.position = 'fixed';
        textArea.style.opacity = '0';
        document.body.appendChild(textArea);
        textArea.select();

        const copied = document.execCommand('copy');
        textArea.remove();

        if (copied) {
          this.showCopiedState();
        } else if (this.status) {
          this.status.textContent = this.dataset.copyError;
        }
      }
    }

    showCopiedState() {
      this.copyButton.textContent = this.dataset.copiedLabel;

      if (this.status) {
        this.status.textContent = this.dataset.copiedLabel;
      }

      window.setTimeout(() => {
        this.copyButton.textContent = this.defaultLabel;
      }, 2000);
    }
  }

  if (!customElements.get('discount-code-copy')) {
    customElements.define('discount-code-copy', DiscountCodeCopy);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["shipping-estimate"] && !Shopify.designMode) return;
  try {
    class ShippingEstimate extends HTMLElement {
    connectedCallback() {
      this.renderDates();
    }

    renderDates() {
      const today = this.getStoreDate();
      let processingStart = new Date(today.date);

      if (!this.isBusinessDay(processingStart) || today.hour >= Number(this.dataset.cutoffHour)) {
        processingStart = this.nextBusinessDay(processingStart);
      }

      const shipMin = this.addBusinessDays(processingStart, Number(this.dataset.handlingMin));
      const shipMax = this.addBusinessDays(processingStart, Number(this.dataset.handlingMax));
      const deliveryMin = this.addBusinessDays(shipMin, Number(this.dataset.transitMin));
      const deliveryMax = this.addBusinessDays(shipMax, Number(this.dataset.transitMax));

      this.querySelector('[data-order-date]').textContent = this.formatDate(today.date);
      this.querySelector('[data-ship-date]').textContent = this.formatRange(shipMin, shipMax);
      this.querySelector('[data-delivery-date]').textContent = this.formatRange(deliveryMin, deliveryMax);
    }

    getStoreDate() {
      const parts = new Intl.DateTimeFormat('en-US', {
        timeZone: this.dataset.timeZone,
        year: 'numeric',
        month: 'numeric',
        day: 'numeric',
        hour: 'numeric',
        hourCycle: 'h23'
      }).formatToParts(new Date());
      const values = Object.fromEntries(parts.map((part) => [part.type, part.value]));

      return {
        date: new Date(Number(values.year), Number(values.month) - 1, Number(values.day), 12),
        hour: Number(values.hour)
      };
    }

    isBusinessDay(date) {
      return date.getDay() !== 0 && date.getDay() !== 6;
    }

    nextBusinessDay(date) {
      const result = new Date(date);

      do {
        result.setDate(result.getDate() + 1);
      } while (!this.isBusinessDay(result));

      return result;
    }

    addBusinessDays(date, days) {
      const result = new Date(date);
      let added = 0;

      while (added < days) {
        result.setDate(result.getDate() + 1);

        if (this.isBusinessDay(result)) {
          added += 1;
        }
      }

      return result;
    }

    formatDate(date) {
      return new Intl.DateTimeFormat('en-US', {
        month: 'short',
        day: 'numeric'
      }).format(date);
    }

    formatRange(start, end) {
      return `${this.formatDate(start)} – ${this.formatDate(end)}`;
    }
  }

  if (!customElements.get('shipping-estimate')) {
    customElements.define('shipping-estimate', ShippingEstimate);
  }
  } catch(e) { console.error(e); }
})();

})();
